module.exports = __webpack_public_path__ + "img/8.3f659e04.webp";